var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbouM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    fill: "#FFC3A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2765 34C26.2658 34 33.5531 26.6127 33.5531 17.5C33.5531 8.3873 26.2658 1 17.2765 1C8.28726 1 1 8.3873 1 17.5C1 26.6127 8.28726 34 17.2765 34Z",
    stroke: "#080C3E",
    strokeWidth: 0.5705,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62025 17.707H8.66699V27.7956H9.62025V17.707Z",
    fill: "#2B8AD8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97404 17.707H8.66699V27.7956H8.97404V17.707Z",
    fill: "#1971BA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4823 27.7949H25.4355V17.7064H24.4823V27.7949Z",
    fill: "#2B8AD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1285 27.7949H25.4355V17.7064H25.1285V27.7949Z",
    fill: "#46AFF7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4822 5.89453H9.62012V13.9579H24.4822V5.89453Z",
    fill: "#6B4444"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4822 13.3652H9.62012V13.9572H24.4822V13.3652Z",
    fill: "#543333"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 12.4141L24.4824 12.4141V12.2593L9.6203 12.2593V12.4141Z",
    fill: "#543333"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 12.2598L24.4824 12.2598V12.105L9.6203 12.105V12.2598Z",
    fill: "#7F5454"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 11.1152L24.4824 11.1152V10.9605L9.6203 10.9605V11.1152Z",
    fill: "#543333"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 10.9609L24.4824 10.9609V10.8062L9.6203 10.8062V10.9609Z",
    fill: "#7F5454"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 9.81641L24.4824 9.81641V9.66168L9.6203 9.66168V9.81641Z",
    fill: "#543333"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 9.66211L24.4824 9.66211V9.50739L9.6203 9.50739V9.66211Z",
    fill: "#7F5454"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 8.51953L24.4824 8.51953V8.36481L9.6203 8.36481V8.51953Z",
    fill: "#543333"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 8.36523L24.4824 8.36523V8.21051L9.6203 8.21051V8.36523Z",
    fill: "#7F5454"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 7.22266L24.4824 7.22266V7.06793L9.6203 7.06793V7.22266Z",
    fill: "#543333"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M9.6203 7.06641L24.4824 7.06641V6.91168L9.6203 6.91168V7.06641Z",
    fill: "#7F5454"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4822 28.3982H9.62012V13.5361L17.0512 6.16211L24.4822 13.5361V28.3982Z",
    fill: "#2B8AD8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.185 12.9746L9.62012 13.5351V28.3972H10.185V12.9746Z",
    fill: "#1971BA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.918 12.9746V28.3972H24.4828V13.5351L23.918 12.9746Z",
    fill: "#46AFF7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6094 22.3887H10.4932V27.2398H23.6094V22.3887Z",
    fill: "#1863A0"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6094 21.9258H10.4932V22.3885H23.6094V21.9258Z",
    fill: "#1971BA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9175 27.041H10.4932V27.2494H23.9175V27.041Z",
    fill: "#46AFF7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M23.537 6.4668H21.375V6.90911H23.537V6.4668Z",
    fill: "#46AFF7"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3498 6.9082H21.5635V8.51846H23.3498V6.9082Z",
    fill: "#2B8AD8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7683 6.9082H21.5635V8.51846H21.7683V6.9082Z",
    fill: "#1971BA"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3494 6.9082H23.1445V8.51846H23.3494V6.9082Z",
    fill: "#46AFF7"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2697 23.0664H15.9453V25.9452H17.2697V23.0664Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1711 23.2168H16.043V25.7939H17.1711V23.2168Z",
    fill: "#DDDDDD"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1147 23.2812H16.1006V25.7286H17.1147V23.2812Z",
    fill: "#F7DB11"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M17.1149 24.3815L16.1007 25.3957V25.2721L17.1149 24.258V24.3815ZM17.1149 23.2814H16.8793L16.1006 24.0601V24.4272L17.1147 23.413L17.1149 23.2814ZM16.2957 23.2814L16.1007 23.4764V23.5999L16.4194 23.2812L16.2957 23.2814ZM17.1149 24.5273L16.1007 25.5414V25.665L17.1149 24.6508V24.5273ZM17.0658 25.7287H17.1149V25.6796L17.0658 25.7287ZM17.1149 25.1171L16.5033 25.7287H16.8811L17.1149 25.4949V25.1171Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2805 23.0664H17.9561V25.9452H19.2805V23.0664Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1818 23.2168H18.0537V25.7939H19.1818V23.2168Z",
    fill: "#DDDDDD"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1245 23.2812H18.1104V25.7286H19.1245V23.2812Z",
    fill: "#F7DB11"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M19.1245 24.3815L18.1104 25.3957V25.2721L19.1245 24.258V24.3815ZM19.1245 23.2814H18.8889L18.1104 24.0601V24.4272L19.1245 23.413V23.2814ZM18.3053 23.2814L18.1104 23.4764V23.5999L18.429 23.2812L18.3053 23.2814ZM19.1245 24.5273L18.1104 25.5414V25.665L19.1245 24.6508V24.5273ZM19.0755 25.7287H19.1245V25.6796L19.0755 25.7287ZM19.1245 25.1171L18.5129 25.7287H18.8908L19.1245 25.4949V25.1171Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5109 23.0664H11.1865V25.9452H12.5109V23.0664Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4133 23.2168H11.2852V25.7939H12.4133V23.2168Z",
    fill: "#DDDDDD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M12.356 23.2812H11.3418V25.7286H12.356V23.2812Z",
    fill: "#F7DB11"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.356 24.3815L11.3418 25.3957V25.2721L12.356 24.258V24.3815ZM12.356 23.2814H12.1203L11.3418 24.0601V24.4272L12.356 23.413V23.2814ZM11.5368 23.2814L11.3418 23.4764V23.5999L11.6604 23.2812L11.5368 23.2814ZM12.356 24.5273L11.3418 25.5414V25.665L12.356 24.6508V24.5273ZM12.3069 25.7287H12.356V25.6796L12.3069 25.7287ZM12.356 25.1171L11.7444 25.7287H12.1222L12.356 25.4949V25.1171Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5207 23.0664H13.1963V25.9452H14.5207V23.0664Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M14.422 23.2168H13.2939V25.7939H14.422V23.2168Z",
    fill: "#DDDDDD"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3657 23.2812H13.3516V25.7286H14.3657V23.2812Z",
    fill: "#F7DB11"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.3659 24.3815L13.3517 25.3957V25.2721L14.3659 24.258V24.3815ZM14.3659 23.2814H14.1302L13.3516 24.0601V24.4272L14.3657 23.413L14.3659 23.2814ZM13.5467 23.2814L13.3517 23.4764V23.5999L13.6703 23.2812L13.5467 23.2814ZM14.3659 24.5273L13.3517 25.5414V25.665L14.3659 24.6508V24.5273ZM14.3168 25.7287H14.3659V25.6796L14.3168 25.7287ZM14.3659 25.1171L13.7543 25.7287H14.1321L14.3659 25.4949V25.1171Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0543 23.0664H20.1934V27.0421H23.0543V23.0664Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9357 23.1582H20.3115V27.0426H22.9357V23.1582Z",
    fill: "#DDDDDD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M22.84 23.2324H20.4082V27.0429H22.84V23.2324Z",
    fill: "#E04444"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6702 25.0957H22.5371V25.4731H22.6702V25.0957Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8692 27.2402H19.3018V27.4235H23.8692V27.2402Z",
    fill: "#7F5454"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1091 27.4238H19.0615V27.6071H24.1091V27.4238Z",
    fill: "#6B4444"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.342 27.6055H18.8281V27.7887H24.342V27.6055Z",
    fill: "#543333"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0938 19.5391H10.2402V20.6087H16.0938V19.5391Z",
    fill: "#46AFF7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8614 19.5391H18.0078V20.6087H23.8614V19.5391Z",
    fill: "#46AFF7"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3386 15.7324H11.9971V19.0253H14.3386V15.7324Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2047 15.9043H12.1318V18.8521H14.2047V15.9043Z",
    fill: "#DDDDDD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1037 15.9785H12.2441V18.7778H14.1037V15.9785Z",
    fill: "#F7DB11"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M13.3481 18.7778L14.1037 18.0222V18.1635L13.4894 18.7779H13.3481V18.7778ZM12.2441 17.2891L13.5547 15.9785H13.1348L12.2441 16.8691V17.2891ZM12.2441 16.343L12.6086 15.9785H12.4672L12.2441 16.2016V16.343ZM12.2441 18.3969L14.1037 16.5373V16.3959L12.2441 18.2555V18.3969ZM12.2441 18.705L14.1037 16.8454V16.704L12.2441 18.5636V18.705ZM13.1369 18.7778L14.1037 17.8109V17.3787L12.7047 18.7778H13.1369Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1063 15.7324H19.7646V19.0253H22.1063V15.7324Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9722 15.9043H19.8994V18.8521H21.9722V15.9043Z",
    fill: "#DDDDDD"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8713 15.9785H20.0117V18.7778H21.8713V15.9785Z",
    fill: "#F7DB11"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.1156 18.7778L21.8712 18.0222V18.1635L21.2568 18.7779H21.1156V18.7778ZM20.0117 17.2891L21.3223 15.9785H20.9023L20.0117 16.8691V17.2891ZM20.0117 16.343L20.3762 15.9785H20.2348L20.0117 16.2016V16.343ZM20.0117 18.3969L21.8713 16.5373V16.3959L20.0117 18.2555V18.3969ZM20.0117 18.705L21.8713 16.8454V16.704L20.0117 18.5636V18.705ZM20.9043 18.7778L21.8712 17.8109V17.3787L20.4722 18.7778H20.9043Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7311 10.6217L17.0527 9.94336L16.3744 10.6217L17.0527 11.3001L17.7311 10.6217Z",
    fill: "#1863A0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7311 12.4381L17.0527 11.7598L16.3744 12.4381L17.0527 13.1165L17.7311 12.4381Z",
    fill: "#1863A0"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9603 12.2077L18.6387 11.5293L17.9603 10.8509L17.2819 11.5293L17.9603 12.2077Z",
    fill: "#1863A0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1439 12.2077L16.8223 11.5293L16.1439 10.8509L15.4655 11.5293L16.1439 12.2077Z",
    fill: "#1863A0"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0513 6.60013L25.3026 14.8513L26.1026 14.0513L17.0513 5L8 14.0513L8.8 14.8513L17.0513 6.60013Z",
    fill: "#7F5454"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M8.52148 14.5744L8.79961 14.8524L17.0508 6.60118L25.3021 14.8524L25.5802 14.5744L17.0508 6.04492L8.52148 14.5744Z",
    fill: "#543333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbouM);
export default __webpack_public_path__ + "static/media/AbouM.bbf4d66d207142b9d23617a321901dd4.svg";
export { ForwardRef as ReactComponent };